export default __webpack_public_path__ + "static/media/0020.29119942.jpg";